import { apiService } from "../apiService";
import urlConfig from "../../config/domain";
import faqsAndResourceConfig from "../../config/faqs&Resourse/faqsConfig";

export const getResoucesContent = (callback, body) => {
  apiService(
    {
      url: faqsAndResourceConfig.resource + "content",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: body,
    },
    callback
  );
};

export const getArticleById = (callback, id) => {
  apiService(
    {
      url: faqsAndResourceConfig.resource + "article/" + id,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};
export const getVideoById = (callback, id) => {
  apiService(
    {
      url: faqsAndResourceConfig.resource + "video/" + id,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};
